import React from "react";
import { Input, Select, Form } from "antd";
import { Controller } from "react-hook-form";
const { Option } = Select;

const formItemLayout = {
  labelCol: {
    xs: { span: 24 },
    sm: { span: 8 },
  },
  wrapperCol: {
    xs: { span: 24 },
    sm: { span: 16 },
  },
};

const EditAddressForm = ({ control, options = {}, watch, errors }) => {
  const { states = [], cities = [], countries = [] } = options;
  const selectedCountry = watch("country");
  const selectedState = watch("state");

  const getCountryOptions = () => {
    const opts = [];
    countries.forEach((country) => {
      opts.push(
        <Option key={country._id} value={country._id}>
          {country.name}
        </Option>
      );
    });
    return opts;
  };

  const getStateOptions = (countryId) => {
    const opts = [];
    states
      .filter((state) => state.country === countryId)
      .forEach((state) => {
        opts.push(
          <Option key={state._id} value={state._id}>
            {state.name}
          </Option>
        );
      });
    return opts;
  };

  const getCityOptions = (stateId) => {
    const opts = [];
    cities
      .filter((city) => city.state === stateId)
      .forEach((city) => {
        opts.push(
          <Option key={city._id} value={city._id}>
            {city.name}
          </Option>
        );
      });
    return opts;
  };

  return (
    <Form {...formItemLayout}>
      <Controller
        name="addressLine1"
        control={control}
        render={({ field }) => (
          <Form.Item
            label="Address Line 1"
            required
            labelAlign="left"
            validateStatus={errors.addressLine1 ? "error" : "success"}
            help={errors?.addressLine1?.message}
          >
            <Input {...field} />
          </Form.Item>
        )}
      />
      <Controller
        name="addressLine2"
        control={control}
        render={({ field }) => (
          <Form.Item
            label="Address Line 2"
            labelAlign="left"
            validateStatus={errors.addressLine2 ? "error" : "success"}
            help={errors?.addressLine2?.message}
          >
            <Input {...field} />
          </Form.Item>
        )}
      />
      <Controller
        name="country"
        control={control}
        render={({ field }) => (
          <Form.Item
            label="Country"
            labelAlign="left"
            required
            validateStatus={errors.country ? "error" : "success"}
            help={errors?.country?.message}
          >
            <Select {...field} style={{ width: "100%" }}>
              {getCountryOptions()}
            </Select>
          </Form.Item>
        )}
      />
      <Controller
        name="state"
        control={control}
        render={({ field }) => (
          <Form.Item
            label="State"
            labelAlign="left"
            required
            validateStatus={errors.state ? "error" : "success"}
            help={errors?.state?.message}
          >
            <Select {...field} style={{ width: "100%" }}>
              {getStateOptions(selectedCountry)}
            </Select>
          </Form.Item>
        )}
      />
      <Controller
        name="city"
        control={control}
        render={({ field }) => (
          <Form.Item
            label="City"
            labelAlign="left"
            required
            validateStatus={errors.city ? "error" : "success"}
            help={errors?.city?.message}
          >
            <Select {...field} style={{ width: "100%" }}>
              {getCityOptions(selectedState)}
            </Select>
          </Form.Item>
        )}
      />
      <Controller
        name="pincode"
        control={control}
        render={({ field }) => (
          <Form.Item
            label="Pincode"
            required
            labelAlign="left"
            validateStatus={errors.pincode ? "error" : "success"}
            help={errors?.pincode?.message}
          >
            <Input {...field} />
          </Form.Item>
        )}
      />
    </Form>
  );
};

export default EditAddressForm;
